import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import InventoryFilter from 'components/inventory/items/InventoryFilter';
import InventoryDataGrid from 'components/inventory/items/InventoryDataGrid';
import DJHPagination from 'components/shared/Pagination';
import InventoryItemsActions from 'components/inventory/items/InventoryItemsActions';
import { toast } from 'react-toastify';
import { convertQueryParamsIntoObject, convertObjectIntoQueryParams } from 'constant/Helpers';
// actions
import { getAllItemsAllOpsData } from 'store/inventory/InventoryActions';
// selectors
import {
  getAllInventoryData,
  getTotalInventoryPageSize,
  getTotalInventoryCurrentPage,
  getTotalInventoryRowCount,
  getInventoryParams,
} from 'store/inventory/InventorySelectors';

const InventoryAllItemsAllOpsPage = () => {
  const inputValues = useSelector((state) => getInventoryParams({ state }));
  const inventoryData = useSelector((state) => getAllInventoryData({ state }));
  const pageSize = useSelector((state) => getTotalInventoryPageSize({ state }));
  const currentPage = useSelector((state) => getTotalInventoryCurrentPage({ state }));
  const rowCount = useSelector((state) => getTotalInventoryRowCount({ state }));
  const [qty, setQty] = useState('');
  const [clickedRow, setClickedRow] = useState('');
  const [isAddItemModalOpen, setIsAddItemModalOpen] = useState(false);
  const [isAddQtyModalOpen, setIsAddQtyModalOpen] = useState(false);
  const [isEditItemQtyModalOpen, setIsEditItemQtyModalOpen] = useState(false);
  const [isUploadExcelModalOpen, setIsUploadExcelModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      dispatch(getAllItemsAllOpsData(queryObj));
    } else {
      dispatch(getAllItemsAllOpsData({}));
    }
  }, []);

  const updateQueryParams = (inputValues) => {
    const queryString = convertObjectIntoQueryParams(inputValues);
    navigate({
      pathname: '/inventory/allItemsAllOps',
      search: queryString,
    });
  };

  const onPageChange = (i) => {
    updateQueryParams({ ...inputValues, page: i });
    dispatch(getAllItemsAllOpsData({ ...inputValues, page: i }));
    document.documentElement.scrollTop = 0;
  };

  const handleSubmit = () => {
    const minqty = inputValues?.minimumQty || -1;
    if (qty === '') {
      updateQueryParams({ ...inputValues, qty: -1, minimumQty: minqty });
      dispatch(getAllItemsAllOpsData({ ...inputValues, qty: -1, minimumQty: minqty }));
    } else {
      if (qty < 0 || isNaN(qty)) {
        toast.error('Please enter a correct quantity');
      } else {
        updateQueryParams({ ...inputValues, qty, minimumQty: minqty });
        dispatch(getAllItemsAllOpsData({ ...inputValues, qty, minimumQty: minqty }));
        dispatch({
          type: 'INVENTORY_PARAMS',
          payload: { ...inputValues, qty, minimumQty: minqty },
        });
      }
    }
  };

  return (
    <div className="quick-actions-table inventory-page">
      <InventoryItemsActions
        defaultParams={inputValues}
        clickedRow={clickedRow}
        setClickedRow={setClickedRow}
        isAddItemModalOpen={isAddItemModalOpen}
        setIsAddItemModalOpen={setIsAddItemModalOpen}
        isAddQtyModalOpen={isAddQtyModalOpen}
        setIsAddQtyModalOpen={setIsAddQtyModalOpen}
        isEditItemQtyModalOpen={isEditItemQtyModalOpen}
        setIsEditItemQtyModalOpen={setIsEditItemQtyModalOpen}
        isUploadExcelModalOpen={isUploadExcelModalOpen}
        setIsUploadExcelModalOpen={setIsUploadExcelModalOpen}
        isAllItemsPage
        isAllCitiesPage
      />
      <InventoryFilter
        inputValues={inputValues}
        handleSubmit={handleSubmit}
        setQty={setQty}
        qty={qty}
        isAllItemsPage
        isAllCitiesPage
      />
      <InventoryDataGrid
        data={inventoryData}
        setClickedRow={setClickedRow}
        setIsAddItemModalOpen={setIsAddItemModalOpen}
        setIsEditItemQtyModalOpen={setIsEditItemQtyModalOpen}
        isAllItemsPage
        isAllCitiesPage
      />
      <DJHPagination
        onPageChange={onPageChange}
        currentPage={+currentPage}
        pageSize={+pageSize}
        itemsCount={+rowCount}
      />
    </div>
  );
};

export default InventoryAllItemsAllOpsPage;
